import React, { useEffect, useState, useRef } from 'react';
import PostListadmin from '../components/PostList.js';
import OnlineUsersSidebar from '../components/OnlineUsersSidebar';
import { useNavigate } from 'react-router-dom';
import Onlineuser from '../components/icon/onlineuser'
import Groupicon from '../components/icon/groupsicon'
import Menuicon from '../components/icon/menuicon'
import Loading  from '../components/icon/loading'
import Newspost from '../components/whatisnew/news'
import Newsicon from '../components/icon/newsicon'
import NewsCarousel from '../components/whatisnew/NewsCarousel'
import Bannericon from '../components/icon/bannerIcon.js'
import Bannerform from '../components/banners/BannerUpload.js'
import BannersShow from '../components/banners/BannerDisplay.js';
import Coolicon from  '../components/icon/coolactivitiesicon.js'
import AddCoolActivity from '../components/addCoolactivities/AddCoolActivity.js'
import Eventlist from './addCoolactivities/EvenlistverticalviewAdmin.js'
import SurveyIcon from '../components/icon/surveyIcon.js'
import SurveyPanel from '../components/survey/SurveyPanel.js'
import HiringIcon from '../components/icon/hiringIcon.js'
import AdminHiringPanel from '../components/AdminHiringPanel.js'
import EventAttendanceIcon from '../components/icon/eventAttendanceIcon.js'
import EventAttendancePanel from '../components/eventAttendance/EventAttendancePanel.js'
import './Useradmin.css'

const Useradmin = ({ user, posts, onRefresh, onLike, likes, userLiked, onLogout, navigateToProfile }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [showOnlineUsers, setShowOnlineUsers] = useState(false);
const [showNews, setShowNews] = useState(false); // <-- FIXED
  const [showDropdown, setShowDropdown] = useState(false); // State for mobile dropdown
  const dropdownRef = useRef(null);
  const [showBanner, setShowBanner] = useState(false);
  const [showCool, setShowCool] = useState(false);
  const [showSurvey, setShowSurvey] = useState(false);
  const [showHiring, setShowHiring] = useState(false);
  const [showAttendance, setShowAttendance] = useState(false);


  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  useEffect(() => {
    if (posts) setLoading(false);
  }, [posts]);

  // Handle clicks outside the dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!user) return <p>Please log in to view the posts.</p>;

const toggleSidebar = (type) => {
  if (type === "online") setShowOnlineUsers(!showOnlineUsers);
  else if (type === "news") setShowNews(!showNews);
  else if (type === "banner") setShowBanner(!showBanner);
  else if (type === "survey") setShowSurvey(!showSurvey);
  else if (type === "cool") setShowCool(!showCool);
  else if (type === "attendance") setShowAttendance(!showAttendance);
  else if (type === "hiring") setShowHiring(!showHiring);

  // Close others when opening one
  if (type !== "online") setShowOnlineUsers(false);
  if (type !== "news") setShowNews(false);
  if (type !== "banner") setShowBanner(false);
  if (type !== "survey") setShowSurvey(false);
  if (type !== "cool") setShowCool(false);
  if (type !== "attendance") setShowAttendance(false);
  if (type !== "hiring") setShowHiring(false);
};

  const closeSidebar = () => {
    setShowOnlineUsers(false);
  };

  const adminNavItems = [
    { id: 'groups', label: 'Groups', menuLabel: 'Groups', Icon: Groupicon, active: false },
    { id: 'online', label: 'Online', menuLabel: 'Online Users', Icon: Onlineuser, active: showOnlineUsers },
    { id: 'news', label: 'News', menuLabel: 'News', Icon: Newsicon, active: showNews },
    { id: 'banner', label: 'Banner', menuLabel: 'Add Banners', Icon: Bannericon, active: showBanner },
    { id: 'survey', label: 'Survey', menuLabel: 'Survey', Icon: SurveyIcon, active: showSurvey },
    { id: 'cool', label: 'Events', menuLabel: 'Add COOL Activities', Icon: Coolicon, active: showCool },
    { id: 'attendance', label: 'Attend Events', menuLabel: 'Attend Events', Icon: EventAttendanceIcon, active: showAttendance },
    { id: 'hiring', label: 'Hiring', menuLabel: 'Hiring Post', Icon: HiringIcon, active: showHiring },
  ];

  const handleNavClick = (id) => {
    if (id === 'groups') {
      navigate('/admin/groups');
      setShowDropdown(false);
      return;
    }
    toggleSidebar(id);
    setShowDropdown(false);
  };

  return (
    <div className="admin-home">
      {loading ? (
        <div style={{ textAlign: 'center' }}><Loading /></div>
      ) : (
        <>
          <div className="admin-layout">
            {isMobile && (
              <div className="admin-mobile-bar" ref={dropdownRef}>
                <button
                  type="button"
                  className="admin-mobile-trigger"
                  onClick={() => setShowDropdown(!showDropdown)}
                  aria-label="Open admin tools"
                  aria-expanded={showDropdown}
                >
                  <Menuicon />
                </button>

                {showDropdown && (
                  <div className="admin-mobile-menu" role="menu">
                    {adminNavItems.map(({ id, menuLabel, Icon, active }) => (
                      <button
                        key={id}
                        type="button"
                        role="menuitem"
                        className={`admin-mobile-item${active ? ' is-active' : ''}`}
                        onClick={() => handleNavClick(id)}
                      >
                        <span className="admin-mobile-item__icon" aria-hidden="true">
                          <Icon size={18} />
                        </span>
                        {menuLabel}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}

            <div className="admin-content-area">
              {!isMobile && (
                <nav className="admin-rail" aria-label="Admin tools">
                  {adminNavItems.map(({ id, label, Icon, active }) => (
                    <button
                      key={id}
                      type="button"
                      className={`admin-rail-btn${active ? ' is-active' : ''}`}
                      onClick={() => handleNavClick(id)}
                      aria-pressed={active}
                      title={label}
                    >
                      <span className="admin-rail-btn__icon" aria-hidden="true">
                        <Icon size={22} />
                      </span>
                      <span className="admin-rail-btn__label">{label}</span>
                    </button>
                  ))}
                </nav>
              )}

              {showOnlineUsers && (
                <div className="admin-panel admin-panel--online">
                  {isMobile && (
                    <button
                      type="button"
                      onClick={closeSidebar}
                      style={{ position: 'absolute', top: 10, right: 10, background: 'none', border: 'none', fontSize: 24, cursor: 'pointer' }}
                      aria-label="Close online users panel"
                    >
                      &times;
                    </button>
                  )}
                  <OnlineUsersSidebar user={user} />
                </div>
              )}

              {showNews && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    }}
    onClick={() => setShowNews(false)} // close when clicking backdrop
  >
    <div onClick={(e) => e.stopPropagation()}>
      <Newspost userId={user.id} onClose={() => setShowNews(false)} />
    </div>
  </div>
)}
{showBanner && (
  <Bannerform onClose={() => setShowBanner(false)} />
)}

{showSurvey && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '12px',
      boxSizing: 'border-box',
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: '100%',
        maxWidth: '720px',
        maxHeight: '92vh',
        overflowY: 'auto',
        background: '#fff',
        borderRadius: '12px',
        padding: '16px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 8 }}>
        <button
          type="button"
          onClick={() => setShowSurvey(false)}
          aria-label="Close survey manager"
          style={{
            border: 'none',
            background: '#f1f5f9',
            borderRadius: '8px',
            width: '36px',
            height: '36px',
            fontSize: '22px',
            lineHeight: 1,
            cursor: 'pointer',
            color: '#334155',
          }}
        >
          &times;
        </button>
      </div>
      <SurveyPanel user={user} page="main" adminMode />
    </div>
  </div>
)}

{showCool && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: '90%',
        maxWidth: '600px',
        background: '#fff',
        borderRadius: '10px',
        padding: '10px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
      }}
    >
         <div onClick={(e) => e.stopPropagation()}>
      <AddCoolActivity onClose={() => setShowCool(false)} /></div>
    </div>
  </div>
)}

{showAttendance && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '12px',
      boxSizing: 'border-box',
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: '100%',
        maxWidth: '720px',
        maxHeight: '92vh',
        overflowY: 'auto',
        background: '#fff',
        borderRadius: '12px',
        padding: '16px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 8 }}>
        <button
          type="button"
          onClick={() => setShowAttendance(false)}
          aria-label="Close event attendance"
          style={{
            border: 'none',
            background: '#f1f5f9',
            borderRadius: '8px',
            width: '36px',
            height: '36px',
            fontSize: '22px',
            lineHeight: 1,
            cursor: 'pointer',
            color: '#334155',
          }}
        >
          &times;
        </button>
      </div>
      <EventAttendancePanel user={user} onClose={() => setShowAttendance(false)} />
    </div>
  </div>
)}

{showHiring && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '12px',
      boxSizing: 'border-box',
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: '100%',
        maxWidth: '920px',
        maxHeight: '92vh',
        overflowY: 'auto',
        background: '#fff',
        borderRadius: '12px',
        padding: '16px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 8 }}>
        <button
          type="button"
          onClick={() => setShowHiring(false)}
          aria-label="Close hiring manager"
          style={{
            border: 'none',
            background: '#f1f5f9',
            borderRadius: '8px',
            width: '36px',
            height: '36px',
            fontSize: '22px',
            lineHeight: 1,
            cursor: 'pointer',
            color: '#334155',
          }}
        >
          &times;
        </button>
      </div>
      <AdminHiringPanel user={user} onRefresh={onRefresh} />
    </div>
  </div>
)}
              <div className="admin-main">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 10 }}>
                  <BannersShow user={user} />
                </div>
                <div style={{ width: '100%', maxWidth: '100%', marginBottom: 10 }}>
                  <NewsCarousel user={user} />
                </div>
                <Eventlist user={user} />
                <div className="admin-discussion">
                  <PostListadmin
                    posts={posts}
                    user={user}
                    onReply={() => {}}
                    onRefresh={onRefresh}
                    onLike={onLike}
                    likes={likes}
                    userLiked={userLiked}
                    preserveOrder
                    hidePagination
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

    </div>
  );
};

export default Useradmin;